// src/components/common/LoadingSkeleton.jsx

import React from 'react';
import PropTypes from 'prop-types';
import styles from './LoadingSkeleton.module.css';

export const SkeletonCard = () => {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonImage}></div>
      <div className={styles.skeletonContent}>
        <div className={styles.skeletonTitle}></div>
        <div className={styles.skeletonText}></div>
        <div className={styles.skeletonText} style={{width: '60%'}}></div>
        <div className={styles.skeletonButtons}>
          <div className={styles.skeletonButton}></div>
          <div className={styles.skeletonButton}></div>
        </div>
      </div>
    </div>
  );
};

export const SkeletonReview = () => {
  return (
    <div className={styles.skeletonReview}>
      <div className={styles.reviewHeader}>
        <div className={styles.skeletonAvatar}></div>
        <div className={styles.skeletonName}></div>
      </div>
      <div className={styles.skeletonTitle}></div>
      <div className={styles.skeletonText}></div>
      <div className={styles.skeletonText}></div>
      <div className={styles.skeletonText} style={{width: '70%'}}></div>
    </div>
  );
};

export const SkeletonStats = () => {
  return (
    <div className={styles.skeletonStats}>
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className={styles.skeletonStatCard}>
          <div className={styles.skeletonStatIcon}></div>
          <div className={styles.skeletonStatValue}></div>
        </div>
      ))}
    </div>
  );
};

export const SkeletonText = ({ width = '100%', height = '16px' }) => {
  return <div className={styles.skeletonText} style={{ width, height }}></div>;
};

SkeletonText.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string
};

export default SkeletonCard;

